export default __webpack_public_path__ + "static/media/limit.298e2e7f.jpg";